<section>
  <div
    class="ds-field"
    [class.ds-fluid]="fluid"
    [class.ds-invalid]="validate && isTouched && isInvalid"
    [class.ds-valid]="validate && isTouched && isValid"
  >
    <input
      #inputElement
      type="tel"
      placeholder=" "
      [id]="id"
      [attr.aria-invalid]="isInvalid"
      [attr.aria-describedby]="'alert-' + id"
      (focus)="onTouched()"
      (input)="onChange(inputElement.value)"
    />
    <label [for]="id">
      <ng-template [ngIf]="label">{{ label }}</ng-template>
      <ng-template [ngIf]="!label">
        <ng-content></ng-content>
      </ng-template>
    </label>
  </div>
  <div class="ds-text-xs ds-mt-2xs" [id]="'alert-' + id">
    <span role="alert" class="ds-text-secondary-red ds-opacity-80">
      {{ error }}
    </span>
    <span class="ds-text-tertiary-mediumgrey">
      {{ hint }}
    </span>
  </div>
</section>
